import styled from "styled-components";
import { RATypography } from "@/components/customs";
import { Row, Col, Grid } from "antd";

const { useBreakpoint } = Grid;

export const HeaderSection = ({ title = "", description = "", sizeTextTitle = "" }) => {
	const screens = useBreakpoint();
	const cssCustom = !sizeTextTitle ? {} : { fontSize: sizeTextTitle };
	return (
		<Row align="middle">
			<Col md={24}>
				<WrapperContent>
					<RATypography variant={screens.xs ? "h4" : "h3"} style={{ ...cssCustom, lineHeight: "32px" }}>
						{title || ""}
					</RATypography>
				</WrapperContent>
				{description ? (
					<RATypography variant="body3" top="12px" color="#595959">
						{description || ""}
					</RATypography>
				) : null}
			</Col>
		</Row>
	);
};

const WrapperContent = styled.div`
	padding: 0px 20px;
	flex-direction: column;
	align-items: center;
	border-left: 2px solid #ffb11a;
`;
